import axios from 'axios';

export const getStatusChangeMetrics = async () => {
    const { data } = await axios.get('/api/status-changes/metrics');
    return data;
};

export const getStatusChanges = async (options = {}) => {
    const params = {};
    if (options.startDate) params.startDate = options.startDate;
    if (options.endDate) params.endDate = options.endDate;
    if (options.programName) params.programName = options.programName;
    if (options.bac) params.bac = options.bac;
    if (options.limit) params.limit = options.limit;
    const { data } = await axios.get('/api/status-changes', { params });
    return data;
};

export const getEnrollmentStatusChangeMetrics = async (options = {}) => {
    const params = {};
    if (options.programName) params.programName = options.programName;
    const { data } = await axios.get('/api/enrollment-status-changes/metrics', { params });
    return data;
};

export const getEnrollmentStatusChanges = async (options = {}) => {
    const params = {};
    if (options.startDate) params.startDate = options.startDate;
    if (options.endDate) params.endDate = options.endDate;
    if (options.programName) params.programName = options.programName;
    if (options.bac) params.bac = options.bac;
    if (options.limit) params.limit = options.limit;
    const { data } = await axios.get('/api/enrollment-status-changes', { params });
    return data;
};

export const getEnrollmentStatusChangeSeries = async (options = {}) => {
    const params = {};
    if (options.startDate) params.startDate = options.startDate;
    if (options.endDate) params.endDate = options.endDate;
    if (options.programName) params.programName = options.programName;
    const { data } = await axios.get('/api/enrollment-status-changes/series', { params });
    return data;
};
